import type { Template } from "@/types";

export const LA_03_H0_V3: Template[] = [
    {
        id: "la-03-h0v3-01",
        name: "LA 01 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 57, y: 69, width: 277, height: 392, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 69, width: 277, height: 392, rotation: 0, imageRotation: 0 },
            { id: "3", x: 820, y: 0, width: 388, height: 531, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h0v3-02",
        name: "LA 02 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 57, y: 48, width: 277, height: 434, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 48, width: 277, height: 434, rotation: 0, imageRotation: 0 },
            { id: "3", x: 987, y: 48, width: 306, height: 434, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h0v3-03",
        name: "LA 03 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 143, y: 0, width: 390, height: 531, rotation: 0, imageRotation: 0 },
            { id: "2", x: 789, y: 83, width: 235, height: 363, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1031, y: 83, width: 234, height: 363, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h0v3-04",
        name: "LA 04 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 210, y: 89, width: 257, height: 353, rotation: 0, imageRotation: 0 },
            { id: "2", x: 773, y: 89, width: 237, height: 353, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1018, y: 89, width: 237, height: 353, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h0v3-05",
        name: "LA 05 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 72, y: 61, width: 302, height: 408, rotation: 0, imageRotation: 0 },
            { id: "2", x: 382, y: 61, width: 302, height: 408, rotation: 0, imageRotation: 0 },
            { id: "3", x: 692, y: 61, width: 302, height: 408, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h0v3-06",
        name: "LA 06 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 220, y: 62, width: 299, height: 408, rotation: 0, imageRotation: 0 },
            { id: "2", x: 528, y: 62, width: 299, height: 408, rotation: 0, imageRotation: 0 },
            { id: "3", x: 835, y: 62, width: 298, height: 408, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h0v3-07",
        name: "LA 07 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 272, y: 81, width: 265, height: 369, rotation: 0, imageRotation: 0 },
            { id: "2", x: 545, y: 81, width: 264, height: 369, rotation: 0, imageRotation: 0 },
            { id: "3", x: 817, y: 81, width: 264, height: 369, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h0v3-08",
        name: "LA 08 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 46, y: 42, width: 288, height: 447, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 42, width: 288, height: 447, rotation: 0, imageRotation: 0 },
            { id: "3", x: 845, y: 42, width: 339, height: 447, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h0v3-09",
        name: "LA 09 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 47, y: 42, width: 313, height: 447, rotation: 0, imageRotation: 0 },
            { id: "2", x: 801, y: 86, width: 249, height: 355, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1058, y: 86, width: 249, height: 355, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h0v3-10",
        name: "LA 10 - H0V3",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h0_v3_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 94, y: 80, width: 288, height: 393, rotation: 0, imageRotation: 0 },
            { id: "2", x: 482, y: 0, width: 387, height: 531, rotation: 0, imageRotation: 0 },
            { id: "3", x: 970, y: 80, width: 288, height: 393, rotation: 0, imageRotation: 0 }
        ],
    }
];